export const RESTRICTED_OPTIONS_RENDER_COUNT = 4;
